import React from 'react';
import PlayListContainer from 'containers/PlayListContainer/PlayListContainer';

export default function PlayListPage() {
    return (
        <PlayListContainer />
    )
}
